import { useBrand } from "../../context/brand";

export const LogoMark = ({ size = 40, className = "", full = false }) => {
  const brand = useBrand();
  return (
    <img src={full ? brand.logo : brand.mark} alt={brand.name} width={size} height={size}
      className={`object-contain ${brand.logoRound ? "rounded-[24%]" : ""} ${className}`} style={{ width: size, height: size }} />
  );
};
